// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/execute-transform-crm-contact-process-request-schema',
  type: 'object',
  required: ['processName'],
  properties: {
    processName: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
